import { render, staticRenderFns } from "./AdminShipmentDocumentList.vue?vue&type=template&id=2d28d8d3&scoped=true"
import script from "./AdminShipmentDocumentList.vue?vue&type=script&lang=js"
export * from "./AdminShipmentDocumentList.vue?vue&type=script&lang=js"
import style0 from "./AdminShipmentDocumentList.vue?vue&type=style&index=0&id=2d28d8d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d28d8d3",
  null
  
)

export default component.exports